import {
  useNavigate,
  useLocation,
  NavigateFunction,
  NavigateOptions,
} from 'react-router';
import { useCallback } from 'react';

const useNavigateSearch = (): NavigateFunction => {
  const navigate = useNavigate();
  const location = useLocation();

  // This function takes the same parameters as navigate but preserves the query string
  const navigateSearch: NavigateFunction = useCallback(
    (to, options: NavigateOptions = {}) => {
      // Construct the new path while preserving the query string from the current location
      const toWithQuery = `${to}${location.search}`;
      navigate(toWithQuery, options);
    },
    [navigate, location.search],
  );

  return navigateSearch;
};

export default useNavigateSearch;
